/**
 * FAQ content. Lives outside the route file: TanStack route splitting strips
 * non-exported module-scope runtime values from the shared route chunk, which
 * broke hydration app-wide ("does not provide an export named FAQS").
 */
import { SITE } from "@/lib/site";
import { cancellationPolicy } from "@/lib/cancellation-policy";

export const FAQS = [
  {
    q: "¿Puedo cancelar mi reserva?",
    a: `Sí. ${cancellationPolicy("es").join(" ")} Si la página del tour muestra condiciones más flexibles, aplican esas. Solicítalo por WhatsApp al ${SITE.contact.phone}.`,
  },
  {
    q: "¿Qué pasa si no puedo asistir el día del tour?",
    a: "Puedes cambiar la fecha gratis hasta 24 h antes, sujeto a disponibilidad. Con menos de 24 h o si no te presentas, no hay reembolso.",
  },
  {
    q: "¿Qué métodos de pago aceptan?",
    a: `Aceptamos ${SITE.policies.payments.join(", ")}. Algunos tours también permiten pago al abordar.`,
  },
  {
    q: "¿Hay descuentos disponibles?",
    a: SITE.policies.discounts
      .map((d) => `Código ${d.code}: ${d.off} para ${d.audience.toLowerCase()}.`)
      .join(" "),
  },
  {
    q: "¿Los tours incluyen transporte?",
    a: "La mayoría de nuestros tours incluyen transporte cómodo y seguro desde puntos seleccionados de la zona hotelera. Revisa los detalles de cada experiencia.",
  },
  {
    q: "¿En qué idiomas están disponibles los guías?",
    a: "Contamos con guías certificados disponibles en varios idiomas. Por favor indícanos tu preferencia al momento de reservar.",
  },
];
